// Internal dependencies
import { appStyles } from '../App.styles';
// Billing styles
export const billingStyles = {
    linearProgress: {
        backgroundColor: '#DBE5DF',
        '& span': {
            backgroundColor: '#006B54',
        }
    },
    usageText: Object.assign(Object.assign({}, appStyles.text14), { textAlign: 'left', padding: '1.5rem 0 1.5rem' }),
    usageNumberText: Object.assign(Object.assign({}, appStyles.text14), { display: 'inline', color: '#006B54' }),
    divider: {
        padding: '1.5rem 0 0',
        borderColor: '#BFC9C3',
    },
};
